import Vector from "../math/Vector";
import { Settings } from '../../Settings';

export default class GridBox {
    /**
     * @param {Vector} origin 
     */
    constructor(origin) {
        /**
         * @type {Vector}
         */
        this.origin = origin;
    }

    // The origin is the top left corner of the box.


    // The y-coordinate increases as we go downwards.
    /**
     * @returns {Vector}
     */
    getOrigin() {
        return this.origin;
    }

    /**
     * @returns {number}
     */
    getPixelWidth() {
        return 0;
    }

    /**
     * @returns {number}
     */
    getPixelHeight() {
        return 0;
    }

    /**
     * @returns {number}
     */
    getOriginTileCol() {
        const col = this.origin.x / Settings.tile.size;

        // if (isNaN(col)) {
        //     console.log('GridBox.getOriginTileCol() NaN. x=' + this.origin.x + ' size=' + Settings.tile.size);
        // }

        return col;
        //return this.origin.x / Settings.tile.size;
    }

    /**
     * @returns {number}
     */
    getOriginTileRow() {
        return this.origin.y / Settings.tile.size;
    }

    // getTileWidth() {
    //     return this.getPixelWidth() / Settings.tile.size;
    // }
    
    // getTileHeight() {
    //     return this.getPixelHeight() / Settings.tile.size;
    // }

    /**
     * @param {Vector} vector 
     * @returns {boolean}
     */
    contains(vector) {
        return (vector.x >= this.origin.x && vector.x < this.origin.x + this.getPixelWidth()) && (vector.y >= this.origin.y && vector.y < this.origin.y + this.getPixelHeight());
    }

    /**
     * @param {number} x 
     * @param {number} y 
     * @returns {boolean}
     */
    containsXY(x, y) {
        return (x >= this.origin.x && x < this.origin.x + this.getPixelWidth()) && (y >= this.origin.y && y < this.origin.y + this.getPixelHeight());
    }

    /**
     * @param {number} x 
     * @param {number} y 
     * @param {number} halfWidth in pixels
     * @returns {boolean}
     */
    intersects(x, y, halfWidth) {
        //  |---x---|

        // If right edge of object is left of this box, then no intersection.
        if (x + halfWidth < this.origin.x) {
            return false;
        }

        // If left edge of object is right of this box, then no intersection.
        if (x - halfWidth > this.origin.x + this.getPixelWidth()) {
            return false;
        }

        // If bottom edge of object is above this box, then no intersection.
        if (y + halfWidth < this.origin.y) {
            return false;
        }

        // If top edge of object is below this box, then no intersection.
        if (y - halfWidth > this.origin.y + this.getPixelHeight()) {
            return false;
        }

        return true;
    }
}